import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    course: null,
    selectedLesson: null,
    selectedProject: null,
    selectedQuiz: null,
    courseTopics: [],
    lessons: [],
    projects: [],
    quizes: [],
    completions: [],
    projectCompletions: [],
    quizCompletions: [],
    content: [],
    isLoading: true,
    contentType: 'lesson',
    contentLineUp: [],
};

export const lessonSlice = createSlice({
    name: 'lesson',
    initialState,
    reducers: {
        setCourse: (state, action) => {
            state.course = action.payload;
        },
        setCourseTopics: (state, action) => {
            state.courseTopics = action.payload;
        },
        setLessons: (state, action) => {
            state.lessons = action.payload;
        },
        setProjects: (state, action) => {
            state.projects = action.payload;
        },
        setQuizes: (state, action) => {
            state.quizes = action.payload;
        },
        setSelectedLesson: (state, action) => {
            state.selectedLesson = action.payload;
        },
        setCompletions: (state, action) => {
            state.completions = action.payload;
        },
        setProjectCompletions: (state, action) => {
            state.projectCompletions = action.payload;
        },
        setQuizCompletions: (state, action) => {
            state.quizCompletions = action.payload;
        },
        setContent: (state, action) => {
            state.content = action.payload;
        },
        setSelectedProject: (state, action) => {
            state.selectedProject = action.payload;
        },
        setSelectedQuiz: (state, action) => {
            state.selectedQuiz = action.payload;
        },
        setContentType: (state, action) => {
            state.contentType = action.payload;
        },
        setContentLineUp: (state, action) => {
            state.contentLineUp = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        reset: state => {
            state.course = null;
            state.selectedLesson = null;
            state.selectedProject = null;
            state.selectedQuiz = null;
            state.contentType = 'lesson';
            state.courseTopics = [];
            state.lessons = [];
            state.projects = [];
            state.quizes = [];
            state.completions = [];
            state.projectCompletions = [];
            state.quizCompletions = [];
            state.content = [];
            state.contentLineUp = [];
            state.isLoading = true;
        },
    },
});

export const {
    setCourse,
    setCourseTopics,
    setLessons,
    setProjects,
    setQuizes,
    setSelectedLesson,
    setCompletions,
    setProjectCompletions,
    setQuizCompletions,
    setLoading,
    setContent,
    reset,
    setContentType,
    setSelectedProject,
    setSelectedQuiz,
    setContentLineUp,
} = lessonSlice.actions;

export default lessonSlice.reducer;
